module.exports = __webpack_public_path__ + "media/shoot.363c7021.ogg";